(function() { // rychle hledani
    $('.js-globalsearch').each(function(i, el) {
        var $container    = $(el);
        var $input        = $container.find('.js-globalsearch-term');
        var $select       = $container.find('.js-globalsearch-modules');
        var $params       = $container.find('.js-globalsearch-params');
        var $showresults  = $container.find('.js-globalsearch-showresults');
        var $resultsaside = $container.find('.js-globalsearch-resultsaside');

        var autocompleteOpen = false;
        var showresultsEnabled = true;

        var onTermChanged = function() {
            var term = $input.val();
            var minLength = $input.autocomplete('option', 'minLength');

            if (term.length < minLength) {
                showresultsEnabled = false;
                $showresults.trigger('globalsearchstatechanged');
            }
        };

        var onShowresultsStateChanged = function(ev) {
            var _class = 'globalsearch-showresults-disabled';

            if (showresultsEnabled) {
                $showresults.removeClass(_class);
            } else {
                $showresults.removeClass(_class).addClass(_class);
            }
        };

        var onShowresultsClick = function(ev) {
            if (!showresultsEnabled) {
                return;
            }

            $input[0].focus();
            if (autocompleteOpen) {
                $input.autocomplete('close');
            } else {
                $input.autocomplete('search');
            }
        };

        var emptyData = { 'status': 'empty', 'modules': { }, 'items': [ { 'textLabel': '- nenalezeny žádné výsledky -', 'htmlLabel': '<span class="globalsearch-result-placeholder globalsearch-result-empty">' + window.poskiLocale.fulltext_nofound + '</span>', 'url': '' } ] };
        var errorData = { 'status': 'error', 'modules': { }, 'items': [ { 'textLabel': '- nastala chyba při hledání -', 'htmlLabel': '<span class="globalsearch-result-placeholder globalsearch-result-error">' + window.poskiLocale.fulltext_error + '</span>', 'url': '' } ] };

        var processHtmlItem = function(item) {
            return { 'value': item.url, 'label': '<span class="globalsearch-result">' + item.htmlLabel + '</span>' };
        };

        var processTextItem = function(item) {
            return { 'value': item.url, 'label': item.textLabel };
        };

        var processDataForAutocomplete = function(data) {
            var isHtml = $input.autocomplete('option', 'html');
            var processItem = isHtml ? processHtmlItem : processTextItem;

            return $.map(data, processItem);
        };

        var onAutocompleteTerm = function( request, response ) {
            var query = { };
            var moduleId = $select.val();
            let paramsType = $params.val();

            var onResponse = function(data) {
                $resultsaside.find('.js-globalsearch-resultsaside-item').each(function(i, el) {
                    var $item = $(el);
                    var moduleId = $item.data('globalsearch-resultsaside-item-module');
                    var moduleData = data.modules[moduleId];
                    var count = 0;
                    var url = '#';

                    if ('undefined' !== typeof moduleData) {
                        count = data.modules[moduleId].count;
                        url = data.modules[moduleId].url;
                    }



                    $item.find('.js-globalsearch-resultsaside-item-url').attr('href', url);
                    $item.find('.js-globalsearch-resultsaside-item-count').text(count);

                    if (count > 0) {
                        $item.show();
                    } else {
                        $item.hide();
                    }
                });

                showresultsEnabled = data.status === 'success';
                response(processDataForAutocomplete(data.items));
            };

            var onRequestSuccess = function(data, status, xhr) {
                try {
                    if (data.items.length === 0) {
                        data = emptyData;
                    }
                } catch (ex) {
                    data = errorData;
                }

                onResponse(data);
            };

            var onRequestError = function(xhr, status, error) {
                var data = errorData;

                onResponse(data);
            };

            query['term'] = request.term;
            if (moduleId) {
                query['modules[]'] = moduleId;
            }

            $.ajax({
                'url':      '/hledani.json',
                'type':     'GET',
                'dataType': 'json',
                'data':     query,
                'success':  onRequestSuccess,
                'error':    onRequestError
            });
        };

        var onAutocompleteSelect = function(ev, ui) {
            var term = $input.val();
            var url = ui.item.value;

            ev.preventDefault();

            if (url === '') {
                return;
            }

            window.location = url + (-1 === url.indexOf('?') ? '?' : '&') + '_term=' + encodeURIComponent(term);
        };

        var onAutocompleteSearch = function(ev, ui) {
            showresultsEnabled = false;
            $showresults.trigger('globalsearchstatechanged');
        };

        var onAutocompleteOpen = function(ev, ui) {
            var isInputFocused = $input.is(':focused');

            autocompleteOpen = true;

            if (!isInputFocused) {
                $input.autocomplete('close');
                return;
            }

            $resultsaside.show();
            $resultsaside.position({ 'my': 'left top', 'at': 'right top', 'of': '.ui-autocomplete' });
        };

        var onAutocompleteClose = function(ev, ui) {
            $resultsaside.hide();

            autocompleteOpen = false;
        };

        var onAutocompleteResponse = function(ev, ui) {
            $showresults.trigger('globalsearchstatechanged');
        };

        var options = {
            'minLength': 3,
            'html':      true,
            'delay':     600,
            'source':    onAutocompleteTerm,
            'select':    onAutocompleteSelect,
            'search':    onAutocompleteSearch,
            'open':      onAutocompleteOpen,
            'close':     onAutocompleteClose,
            'response':  onAutocompleteResponse
        };

        if ($('.homeSearch').length > 0)
            options['position'] = ({ 'my': 'right top', 'at': 'right top' , 'of': '.JS-homeSearchAnchor'});

        $input.autocomplete(options);
        $input.autocomplete({
            appendTo: $(".JS-homeSearchAnchor")
        });

        $input.bind('change keyup', onTermChanged);
        $showresults.bind('click', onShowresultsClick);
        $showresults.bind('globalsearchstatechanged', onShowresultsStateChanged);
        $showresults.trigger('globalsearchstatechanged');
        onTermChanged();
    });
}());
